import { Button } from "antd";
import type { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PermissionCheck from "~Common/PermissionCheck";
import type { ExportConfig } from "~components/DataTable/types/exportConfig.ts";
import type { ImportConfig } from "~components/DataTable/types/importConfig.ts";
import { ExportModal } from "~components/ExportModal/ExportModal.tsx";
import { ImportModal } from "~components/ImportButton/ImportModal.tsx";
import { type PermissionNames, PermissionOperations } from "~enums/permissions.ts";

type DataTableActionsProps = {
  handleAdd?: () => void;
  permissionNames: Array<PermissionNames>;
  addButtonIntlKey?: string;
  importConfig?: ImportConfig;
  exportConfig?: ExportConfig;
  customActions?: ReactNode;
};

export const DataTableActions = ({
  handleAdd,
  permissionNames,
  addButtonIntlKey,
  importConfig,
  exportConfig,
  customActions,
}: DataTableActionsProps) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <div className="data-table-container-header-actions">
        {customActions}
        {handleAdd && (
          <PermissionCheck permissionKeys={permissionNames} permissionOptions={[PermissionOperations.CREATE]}>
            <Button onClick={handleAdd} type="primary" icon={<i className="fa-solid fa-plus mr-1"></i>}>
              <FormattedMessage id={addButtonIntlKey || "add"} />
            </Button>
          </PermissionCheck>
        )}
        {importConfig && (
          <PermissionCheck permissionKeys={permissionNames} permissionOptions={[PermissionOperations.CREATE, PermissionOperations.UPDATE]}>
            <ImportModal
              title={formatMessage({ id: importConfig.titleIntlKey || "import.modal.title" })}
              description={formatMessage({ id: importConfig.descriptionIntlKey || "import.modal.description" })}
              startImporting={importConfig.handleImport}
              buttonType="button"
            />
          </PermissionCheck>
        )}
        {exportConfig && (
          <PermissionCheck permissionKeys={permissionNames} permissionOptions={[PermissionOperations.READ]}>
            <ExportModal
              handleExport={exportConfig?.handleExport}
              defaultFields={exportConfig.defaultFields}
              groupedFields={exportConfig.groupedFields}
              localStorageKey={exportConfig.localStorageKey}
              loading={exportConfig.loading}
              buttonType="button"
            />
          </PermissionCheck>
        )}
      </div>
    </>
  );
};
